<template>
  <div class="text-center">
    <div class="heading-5 font-weight-medium">Connecting with Leap"</div>
    <v-progress-circular
      indeterminate
      :size="80"
      :width="6"
      color="primary"
      class="mt-10"
    ></v-progress-circular>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "WithLeap",
  props: {
    wallet: {
      type: Object,
    },
    project: {
      type: Object,
    },
  },
  computed: mapGetters({
    activeBackend: "walletUtils/getActiveBackend",
    validBackend: "walletUtils/getValidBackend",
  }),
  methods: {
    async connect() {
      this.$store.dispatch("walletUtils/setBackend", this.wallet.name);
      try {
        await this.$store.dispatch("walletUtils/importBackend", {
          leapOptions: {
            project: this.project.name,
            chainId: this.project.staking.chainId,
          },
        });
        if (this.validBackend && this.validBackend !== true) {
          throw new Error(this.validBackend);
        }
        const account = await this.activeBackend.getAccount();
        const { address: accountAddress } = await account.getAddress();
        this.$emit("next", accountAddress);
      } catch (error) {
        console.log('ERROR', error);
        this.$store.dispatch("walletUtils/cleanUpBackend");
        this.$emit("onError", error);
      }
    },
  },
  mounted() {
    this.connect();
  },
};
</script>
